import React from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import {
  hydrateCriticalStorage,
  hydrateFirebaseAuthStorage,
} from "./utils/appStorage";
import { createPerfTrace } from "./utils/perfLogger";
import "./index.css";

if (!Capacitor.isNativePlatform()) {
  const { hash, origin } = window.location;
  if (hash && hash.startsWith("#/")) {
    window.history.replaceState(null, "", `${origin}${hash.slice(1)}`);
  }
}

const root = createRoot(document.getElementById("root"));

const renderApp = async () => {
  const trace = createPerfTrace("bootstrap.renderApp");
  const { default: App } = await import("./App");
  trace.step("appModuleImported");
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  trace.end("rootRendered");
};

const bootstrap = async () => {
  const trace = createPerfTrace("bootstrap");
  try {
    await hydrateCriticalStorage();
    trace.step("criticalStorageHydrated");
    await hydrateFirebaseAuthStorage();
    trace.step("firebaseAuthStorageHydrated");
  } catch (error) {
    trace.fail(error, { phase: "storageHydration" });
    console.warn("[storage] Failed to hydrate critical app storage", error);
  }

  await renderApp();
  trace.end("complete");
};

void bootstrap();
